export default {
  encryption(data) {
    // let email = "tenant@thingsboard.org";
    // let pwd = "tenant";
    // let param = {"username": "tenant@thingsboard.org", "password": "tenant"};
    // // let obj = this.compileStr(pwd);
    // // let objStr = this.unCompileStr(obj);
    // // console.log("aaaaaaaaaa",obj,"   ",objStr)
    //
    // // let obj = this.compileStr(pwd);
    // // let base64 = window.btoa(obj)
    // // console.log("111111111",  base64);
    // // let objStr = this.unCompileStr(window.atob(base64));
    // // console.log("2222222", objStr);

    let obj = this.compileStr(data);
    let obj1 = "";
    obj1 =  window.btoa(obj);
    return obj1;
  },

  deciphering(data) {
    let objStr = "";
    let objStr1 = "";
    objStr = window.atob(data);
    objStr1 = this.unCompileStr(objStr);
    return  objStr1;
  },

  compileStr(code) {
    let c=String.fromCharCode(code.charCodeAt(0)+code.length);
    for(let i=1;i<code.length;i++){
      c+=String.fromCharCode(code.charCodeAt(i)+code.charCodeAt(i-1));
    }
    return escape(c);
  },

  unCompileStr(code) {
    code = unescape(code);
    let c = String.fromCharCode(code.charCodeAt(0)-code.length);
    for(let i = 1;i < code.length;i++){
      c+=String.fromCharCode(code.charCodeAt(i)-c.charCodeAt(i-1));
    }
    return c;
  },
}



// WEBPACK FOOTER //
// ./src/tool/commonFun.js